import { render, staticRenderFns } from "./teacherlist.vue?vue&type=template&id=6095123a&scoped=true"
import script from "./teacherlist.vue?vue&type=script&lang=js"
export * from "./teacherlist.vue?vue&type=script&lang=js"
import style0 from "./teacherlist.vue?vue&type=style&index=0&id=6095123a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095123a",
  null
  
)

export default component.exports